import { TransportOption } from './../model/transport-option';
import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServiceResponse } from '@sdbn/appclient';
import { Identity } from '@sdbn/appclient';
import { RoutingRule } from '../model/routing-rule';

@Injectable({
  providedIn: 'root'
})
export class RoutingRuleService {
  constructor(private tmcHttpService: HttpService) { }

  getTransportOptions(): Observable<TransportOption[]> {
    return this.tmcHttpService.postWithContext<TransportOption[]>(environment.routingRulesEndpoint + '/transport-options', {});
  }

  getRoutingRules(): Observable<RoutingRule[]> {
    return this.tmcHttpService.postWithContext<RoutingRule[]>(environment.routingRulesEndpoint, {});
  }

  createRoutingRule(routingRule: RoutingRule): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext<ServiceResponse>(environment.routingRulesEndpoint + '/create', routingRule);
  }

  saveRoutingRule(routingRule: RoutingRule): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext<ServiceResponse>(environment.routingRulesEndpoint + '/save', routingRule);
  }

  deleteRoutingRule(identity: Identity): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext<ServiceResponse>(environment.routingRulesEndpoint + '/delete', identity);
  }
}
